import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UserResponseModel } from '../interfaces/responses/models';

@Injectable({
  providedIn: 'root'
})
export class RegisterService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  private createCompleteUrl(path: string): string {
    return `${this.apiUrl}${path}`;
  }

  registerUser(userData: any): Observable<UserResponseModel> {
    return this.http.post<UserResponseModel>(this.createCompleteUrl('users/'), userData);
  }
}
